export default __webpack_public_path__ + "static/media/inl.736db2ee.jpeg";